<template>
    <div>
        <section class="content-header">
            <h1 class="pull-left">
                <font-awesome-icon icon="users"/>
                Users in {{ organizationName }}
            </h1>
            <h3  class="pull-right" v-if="ownerId === $auth.user().id">
                <router-link v-b-tooltip.hover title="Add user" :to="{name : 'organization.users.create'}"
                             class="btn btn-xs btn-success">
                    <font-awesome-icon icon="plus"/>
                </router-link>
            </h3>
        </section>
        <error-component
                v-if="exceptions.length > 0"
                v-bind="exceptions[0]">
        </error-component>
        <success-component
                v-if="success.length > 0"
                :message="success">
        </success-component>
        <b-table :items="users" :fields="fields" stacked="sm">
            <template v-if="ownerId === $auth.user().id" slot="actions" slot-scope="row">
                <b-button-group>
                    <button type="submit" class="btn btn-danger btn-xs" v-b-tooltip.hover
                            title="Delete from organization"
                            @click.prevent="del(row.item.id, row.index)">
                        <font-awesome-icon icon="trash-alt"/>
                    </button>
                </b-button-group>
            </template>
        </b-table>
    </div>
</template>

<script>
    import SuccessComponent from '../../../components/Success.vue';
    import ErrorComponent from '../../../components/ErrorView.vue';
    import {mapState} from 'vuex';

    export default {
        props: ['organization_id'],
        data() {
            return {
                organizationName: '',
                ownerId: 0,
                fields: ['name', 'email', 'actions']
            }
        },
        components: {
            SuccessComponent,
            ErrorComponent
        },
        created() {
            this.$store.dispatch('fetchUsers', this.organization_id);
            if(this.organizations.length > 0) {
                this.organizationName = this.$store.getters.getOrganizationById(parseInt(this.organization_id)).name;
                this.ownerId = this.$store.getters.getOrganizationOwnerId(parseInt(this.organization_id));
            }
        },
        beforeDestroy() {
            this.$store.commit('SET_USERS', []);
            this.$store.dispatch('clearMessages');
        },
        computed: {
            ...mapState({
                users: 'users',
                organizations: 'organizations',
                success: 'success',
                exceptions: 'exceptions'
            }),
        },
        methods: {
            del(userId) {
                this.$swal({
                    title: 'Be careful',
                    text: "Are you sure?",
                    type: 'warning',
                    width: '350px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('deleteUserOrganization', {
                            userId: userId,
                            organizationId: this.organization_id
                        });
                    }
                })
            }
        },
        watch: {
            'organizations'(val) {
                this.organizationName = this.$store.getters.getOrganizationById(parseInt(this.organization_id)).name;
                this.ownerId = this.$store.getters.getOrganizationOwnerId(parseInt(this.organization_id));
            },
        },
    }
</script>